import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CommonService from "../../services/common.service";
import { API_URLS } from "../../constants/api-urls";
import { unwrapApiData } from "./cm/cmProductionPaths";

/** Opens Generate E-Way Bill with invoice from CM fulfillment snapshot. */
export default function SellerCmProductionEwayPage() {
  const { rfqId } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await CommonService.post(API_URLS.CONTRACT_MANUFACTURER.SELLER_FULFILLMENT_ENSURE_PO(rfqId), {});
        const res = await CommonService.get(API_URLS.CONTRACT_MANUFACTURER.SELLER_FULFILLMENT(rfqId));
        const data = unwrapApiData(res);
        const invoiceId = data?.invoice?.id;
        if (!invoiceId) {
          throw new Error("Create and send the invoice before generating an e-way bill.");
        }
        if (!cancelled) {
          navigate("/eway-bill-generate", {
            replace: true,
            state: { invoiceId, cmRfqId: Number(rfqId) },
          });
        }
      } catch (e) {
        const m = e?.response?.data?.message || e?.message || "Failed to open e-way bill";
        toast.error(m);
        if (!cancelled) navigate("/seller/cm-rfqs", { replace: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [rfqId, navigate]);

  return (
    <div className="container py-5">
      <p className="text-muted mb-0">Loading CM fulfillment…</p>
    </div>
  );
}
